<template>
  <b-container>
    <div class="body-wrapper" v-if="RegType < 11">
      <div class="body-title">
        <b-row>
          <b-col>
            <h5 style="color: #2284ab">Dashboard</h5>
          </b-col>
          <b-col style="text-align: right">
            <div style="float: right; margin-top: -0.7rem">
              <span>
                <small>Profile Completion:</small>
              </span>
              <b-progress
                :max="max"
                class="w-75 float-right"
                style="background-color: #a0a3a7"
              >
                <b-progress-bar :value="counter">
                  <strong>{{ counter }} / {{ max }}</strong>
                </b-progress-bar>
              </b-progress>
            </div>
            <b-btn
              v-if="validProfile"
              variant="secondary"
              size="sm"
              @click="submit"
              >Create Profile</b-btn
            >
            <div class="d-flex justify-content-between align-items-center mt-3" v-if="PolicePending == 1 || bothDocumentsUploaded ">
                  <h6 class="mb-0 text-danger">
                    {{
                      bothDocumentsUploaded
                        ? "Your Police and Medical Verification documents"
                        : "Please upload your Police and Medical Verification documents"
                    }}
                  </h6>

                  <b-button
                    variant="primary"
                    size="sm"
                    @click="openCombinedModal1"
                    v-if="PolicePending == 1"
                  >
                    Upload Document
                  </b-button>

                  <b-button
                    variant="success"
                    size="sm"
                    @click="openCombinedModal1"
                    v-else-if="bothDocumentsUploaded"
                  >
                    View Document
                  </b-button>
                </div>
             <!-- <div class=" justify-content-between align-items-center mt-3" v-if="this.PolicePending==1">
              <h6 class="mb-0 text-danger">
                {{
                  bothDocumentsUploaded
                    ? "Your Police and Medical Verification documents"
                    : "Please upload your Police and Medical Verification documents"
                }}
              </h6>

              <b-button  variant="primary" size="sm" @click="openCombinedModal1">
                {{
                  bothDocumentsUploaded ? "View Document" : "Upload Document"
                }}
              </b-button>
            </div> -->
            <!-- <div class="d-flex justify-content-between align-items-center mt-3">
            <h6 class="mb-0 text-danger">
              {{
                PolicePending == 1
                  ? "Please upload your Police and Medical Verification documents"
                  : "Your Police and Medical Verification documents"
              }}
            </h6>

            <b-button variant="primary" size="sm" @click="openCombinedModal1">
              {{ PolicePending == 1 ? "Upload Document" : "View Document" }}
            </b-button>
          </div> -->
            <Spinner size="16" message="Loading..." v-if="isLoading2"></Spinner>
          </b-col>
           <b-modal
              ref="combinedModal"
              id="combined-verification-modal"
              size="lg"
              title="Police & Medical Verification"
              hide-footer
            >
              <!-- Police Verification -->
              <div class="row">
                <div class="col-md-5">
                  <label
                    class="text-danger font-weight-bold"
                    style="text-align: left"
                  >
                    Please Upload Police Certificate
                    <span class="text-danger">*</span>
                  </label>
                </div>

                <div class="col-md-3">
                  <b-form-file
                    v-if="!isViewOnly"
                    ref="policeFileInput"
                    accept=".jpg, .png, .gif, .pdf"
                    size="sm"
                    v-model="PoliceVerification"
                    plain
                    style="max-width: 100%"
                    @change="onFileChange1"
                  ></b-form-file>
                </div>
                <div class="col-md-4">
                  <div
                    v-if="form.UserDocuments.PoliceVerification"
                    class="d-flex align-items-center mt-2"
                  >
                    <a
                      :href="getImgUrl2(form.UserDocuments.PoliceVerification)"
                      target="_blank"
                    >
                      <img
                        :src="getImgUrl(form.UserDocuments.PoliceVerification)"
                        width="50"
                        class="mr-2"
                      />
                    </a>
                    <b-button
                      v-if="!isViewOnly"
                      size="sm"
                      variant="outline-danger"
                      class="pt-0 pb-0"
                      @click.stop="
                        deleteDocument2(
                          'PoliceReceipt',
                          form.UserDocuments.PoliceVerification,
                          1
                        )
                      "
                      v-b-tooltip.hover
                      title="Delete Document"
                    >
                      <i
                        class="fa fa-trash text-danger"
                        style="font-size: 16px"
                      ></i>
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <label class="text-danger font-weight-bold mb-2 d-block">
                    Please Upload Medical Certificate
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <div class="col-md-3">
                  <b-form-file
                    v-if="!isViewOnly"
                    ref="medicalFileInput"
                    accept=".jpg, .png, .gif, .pdf"
                    size="sm"
                    v-model="MedicalCertificate"
                    plain
                    style="max-width: 100%"
                    @change="onFileChangenew"
                  ></b-form-file>
                </div>
                <div class="col-md-3">
                  <div
                    v-if="form.UserDocuments.MedicalCertificate"
                    class="d-flex align-items-center mt-2"
                  >
                    <a
                      :href="getImgUrl2(form.UserDocuments.MedicalCertificate)"
                      target="_blank"
                    >
                      <img
                        :src="getImgUrl(form.UserDocuments.MedicalCertificate)"
                        width="50"
                        class="mr-2"
                      />
                    </a>
                    <b-button
                      v-if="!isViewOnly"
                      size="sm"
                      variant="outline-danger"
                      class="pt-0 pb-0"
                      @click.stop="
                        deleteDocument2(
                          'MedicalReceipt',
                          form.UserDocuments.MedicalCertificate,
                          2
                        )
                      "
                      v-b-tooltip.hover
                      title="Delete Document"
                    >
                      <i
                        class="fa fa-trash text-danger"
                        style="font-size: 16px"
                      ></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <template #modal-footer>
                <div class="text-center w-100" v-if="!isViewOnly">
                  <b-button
                    v-if="PoliceVerification && MedicalCertificate"
                    variant="primary"
                    @click="submitBothDocuments"
                    >Submit</b-button
                  >
                  <b-button variant="secondary" class="ml-2" @click="cancelBoth"
                    >Cancel</b-button
                  >
                </div>
              </template>
            </b-modal>
        </b-row>
      </div>
      <div class="body-content">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert = false"
          :variant="variant"
          >{{ alertText }}</b-alert
        >
        <b-row class="mb-2">
          <b-col md="4">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type to Search"
                size="sm"
              />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''" size="sm"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col></b-col>
          <b-col md="4">
            <b-form-group
              horizontal
              label="Sort"
              class="mb-0"
              label-size="sm"
              label-cols="1"
            >
              <b-input-group>
                <b-form-select
                  v-model="sortBy"
                  :options="sortOptions"
                  size="sm"
                >
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-input-group-append>
                  <b-form-select
                    :disabled="!sortBy"
                    v-model="sortDesc"
                    size="sm"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table
          show-empty
          head-variant="dark"
          empty-text="No Posting available at this time. Keep Looking this space for new openings"
          stacked="md"
          bordered
          striped
          :items="events"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size: 12px"
        >
          <template slot="details" slot-scope="row">
            <!-- <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)" 
                      class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                      Details
            </b-button>-->
            <a :href="s3bucketpath(row.item)" target="_blank">View</a>
          </template>
          <template slot="details" slot-scope="row">
            <!-- <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)" 
                      class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                      Details
            </b-button>-->
            <a :href="s3bucketpath(row.item)" target="_blank">View</a>
          </template>
          <template slot="action" slot-scope="row">
            <b-button
              size="sm"
              v-if="!row.item.ApplyStatus"
              @click.stop="applyforJob(row.item, row.index, $event.target)"
              class="mr-1 pt-0 pb-0"
              variant="outline-danger"
              v-b-tooltip.hover
              title="Apply for the post"
              >Apply</b-button
            >
          </template>
        </b-table>
        <b-row>
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group
              horizontal
              label="Per page"
              class="mb-0"
              label-size="sm"
              :label-cols="6"
            >
              <b-form-select
                :options="pageOptions"
                v-model="perPage"
                size="sm"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal ref="myModalRef" id="modal1" title="Job Details" size="lg">
      <b-table stacked small hover :items="itemsa"></b-table>
    </b-modal>
    <b-modal
      @hidden="MarkNotificationRead"
      ref="mdlNotification"
      id="mdlNotification"
      title="NOTIFICATION"
      size="lg"
    >
      <b-table
        small
        hover
        :items="notifications"
        :fields="notificationField"
      ></b-table>
    </b-modal>
     <b-modal id="modalConfirm1" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button
          variant="danger"
          @click="modalConfirmnew"
          style="margin-left: 5px"
          >Delete</b-button
        >
        <b-button variant="info" @click="modalCancel" style="margin-left: 5px"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm"
      centered
      hide-footer
      title="Incomplete Profile"
      size="sm"
    >
      <p>To apply for this job, you need to complete your profile</p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn class="float-right" size="sm" variat="info" to="/profile"
          >Create Profile</b-btn
        >
      </div>
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import axios from "axios";

import lambda from "@/apis/lambda";
import Spinner from "vue-simple-spinner";

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];
export default {
  components: { Spinner },
  data() {
    return {
      PoliceVerification: null,
      isViewOnly: false,
      PolicePending: 0,
      token: "",
      userinfo: "",
      UserBFormID: "",
      PoliceVerification: "",
      MedicalCertificate: "",
      selecteObj: {
        Document: "",
        Path: "",
      },
      showDismissibleAlert: false,
      PoliceVerification: null,
      MedicalCertificate: null,
      form: {
        UserDocumentUpload: {
          PoliceVerificationStatus: false,
          MedicalVerificationStatus: false,
        },
        UserDocuments: {
          PoliceVerification: "",
          MedicalCertificate: "",
        },
        LoginID: "",
        UserApplication: [{ UserApplicationID: "" }],
      },
      variant: "success",
      deleteflag: 1,
      alertText: "",
      isLoading: true,
      isLoading2: false,
      notifications: [],
      notificationField: [{ key: "NotificationMessage", label: "Message" }],
      events: [
        {
          EventTitle: "Test",
          EventTotalPosts: 1,
          EventDescription: "",
          EventMalePosts: 1,
          EventFemalePosts: 0,
          ApplicationStartDt: "22-Jan-2020",
          ApplicationEndDt: "22-Jan-2020",
          EventID: "00000000-1234-5678-0000-000000000000",
          EventDetailsFile: "Events.pdf",
          BoardID: "A1BFDFD8-DB30-4D39-87F7-5F2EDDD7F810",
          ApplyStatus: false,
        },
      ],
      itemsa: [],
      counter: 0,
      max: 0,
      maxnew: 0,
      Status: "",
      isPoiceMedicDone: "",
      fields: [
        { key: "EventTitle", label: "Job Title", sortable: true },
        // { key: "EventTotalPosts", label: "Total Posts", sortable: true },
        // { key: "EventMalePosts", label: "Posts For Male", sortable: true },
        // { key: "EventFemalePosts", label: "Posts For Female", sortable: true },
        {
          key: "ApplicationStartDt",
          label: "Application Start Date",
          formatter: "convertDateFormatStart",
          sortable: true,
        },
        {
          key: "ApplicationEndDt",
          label: "Application End Date",
          formatter: "convertDateFormatEnd",
          sortable: true,
        },
        { key: "details", label: "Detail" },
        { key: "ApplicationNo", label: "Application No" },
        {
          key: "ApplicationDate",
          label: "Application Date",
          formatter: "convertDateFormat",
        },
        { key: "details", label: "Details" },
        { key: "action", label: "Apply" },
      ],
      currentPage: 1,
      UserBFormID: "",
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedEventId: "",
      RegType: 0,
    };
  },
  computed: {
     bothDocumentsUploaded() {
      return (
        this.form.UserDocuments.PoliceVerification &&
        this.form.UserDocuments.MedicalCertificate
      );
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log (x);
      return x;
    },
    validProfile() {
      var nme = this.$store.getters.loggedUser;
      return nme.ValidProfile;
    },
  },
  methods: {
      onSubmit() {
      this.showDismissibleAlert = false;

      // Validation
      if (this.form.UserDocuments.PoliceVerification == "") {
        this.alertText =
          "Police Verification Receipt or Certificate is compulsory";
        this.showDismissibleAlert = true;
        this.variant = "danger";
        return;
      }
      if (this.form.UserDocuments.MedicalCertificate == "") {
        this.alertText = "Medical Receipt or Certificate is compulsory";
        this.showDismissibleAlert = true;
        this.variant = "danger";
        return;
      }

      // Populate additional info
      var userinfo = this.$store.getters.loggedUser;
      this.form.RegType = userinfo.RegistrationType;
      this.form.LoginID = userinfo.UserId;
      this.form.UserBFormID = this.UserBFormID;
      this.form.UserApplication[0].UserApplicationID =
        this.$route.params.applicationId;

      var payload = {
        LoginID: this.form.LoginID,
        UserBFormID: this.UserBFormID,
        UserDocuments: this.form.UserDocuments,
      };

      console.log(payload);

      let promise = apis.saveDocumentPath(payload);

      promise
        .then((response) => {
          console.log(response.status);
          if (response.status == 200) {
            
            // var user = this.userinfo;
            // user.PolicePending = 0;

            // this.$store.dispatch("login", {
            //   token: this.token,
            //   user: user,
            // });

            this.PolicePending = 0;

            this.alertText = response.body || "Saved successfully.";
            this.variant = "success";
            this.showDismissibleAlert = true;

            // this.loadImageList();
            // this.saved = true;

            // setTimeout(() => {
            //   this.showDismissibleAlert = false;
            // }, 4000);

            // this.$refs.policeModal.hide();
          } else {
            this.alertText = response.body || "Something went wrong.";
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }

          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body || "Error occurred while saving.";
          this.variant = "danger";
          this.showDismissibleAlert = true;
          this.isLoading = false;
        });
    },
   
    submitBothDocuments() {
      // Handle both file uploads here
      this.onSubmit(); // for police
      // this.onSubmitNew(); // for medical
      this.$refs.combinedModal.hide();
    },
     getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          this.userId +
          "/" +
          pic
        );
      }
    },
     getImgUrl2(pic) {
      if (pic) {
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          this.userId +
          "/" +
          pic
        );
      }
    },
     loadImageList() {
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      //   var filename =   this.Photo.name;
      let promise = apis.readVeriDocumentPath(userid);
      this.docTbl = [];
      promise
        .then((response) => {
          //console.log(response);
          if (response.status == 200) {
            this.form.UserDocuments = response.body;
            this.docObj = response.body;
            for (var key in this.docObj) {
              if (this.docObj.hasOwnProperty(key)) {
                if (this.docObj[key]) {
                  if (this.docObj[key] != "") {
                    let link =
                      "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
                      userid +
                      "/" +
                      this.docObj[key];

                    this.docTbl.push({
                      Document: key,
                      Path: this.docObj[key],
                      link: link,
                    });
                  }
                }
                //console.log(key + " -> " + this.docObj[key]);
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
     onFileChange1(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1];
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPhoto.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var now = new Date();
      var timestamp =
        now.getFullYear() +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        ("0" + now.getDate()).slice(-2) +
        "_" +
        ("0" + now.getHours()).slice(-2) +
        ("0" + now.getMinutes()).slice(-2) +
        ("0" + now.getSeconds()).slice(-2);
      var filepath = "PoliceVerification_" + timestamp + "." + extn;
      var filepath = "PoliceVerification_." + extn;

      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);
      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.PoliceVerification = filepath;
            this.form.UserDocumentUpload.PoliceVerificationStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onFileChangenew(e) {
      //alert();
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1];
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPhoto.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var now = new Date();
      var timestamp =
        now.getFullYear() +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        ("0" + now.getDate()).slice(-2) +
        "_" +
        ("0" + now.getHours()).slice(-2) +
        ("0" + now.getMinutes()).slice(-2) +
        ("0" + now.getSeconds()).slice(-2);
      var filepath = "MedicalVerification_" + timestamp + "." + extn;
      var filepath = "MedicalVerification_." + extn;

      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);
      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            // alert(filepath);
            this.form.UserDocuments.MedicalCertificate = filepath;
            // alert(this.form.UserDocuments.MedicalCertificate);
            this.form.UserDocumentUpload.MedicalVerificationStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    cancelBoth() {
      this.form.UserDocuments.PoliceVerification = "";
      this.form.UserDocuments.MedicalCertificate = "";
      this.$refs.policeFileInput && this.$refs.policeFileInput.reset();
      this.$refs.medicalFileInput && this.$refs.medicalFileInput.reset();

      this.$refs.combinedModal.hide();
    },
      openCombinedModal1() {
      this.isViewOnly =
        this.form.UserDocuments.PoliceVerification &&
        this.form.UserDocuments.MedicalCertificate;
        if (this.PolicePending==1) 
        {
          this.isViewOnly = false;
        }
      this.$refs.combinedModal.show();
    },
    openCombinedModal() {
      this.isViewOnly =
        this.form.UserDocuments.PoliceVerification &&
        this.form.UserDocuments.MedicalCertificate;

      this.form.UserDocuments.PoliceVerification = "";
      this.form.UserDocuments.MedicalCertificate = "";

      this.$refs.combinedModal.show();
    },
    deleteDocument2(document, path, deleteflag) {
      //console.log(item);
      this.deleteflag = deleteflag;
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm1");
    },
    convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      if (dbDateTime.getFullYear() == 1) {
        return null;
      }

      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate;
    },
    convertDateFormatStart(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate + " 09:00 AM";
    },
    convertDateFormatEnd(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate + " 05:00 PM";
    },
    s3bucketpath(rowdtl) {
      return (
        "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
        rowdtl.EventID +
        "/" +
        rowdtl.EventDetailsFile
      );
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDetails(item, index, button) {
      this.selectedEventId = item.EventID;
      let promise = apis.getEventbyId(item.EventID);
      promise
        .then((response) => {
          if (response.status == 200) {
            //console.log("Items", response.body);
            this.isLoading = false;
            this.itemsa.push(response.body);
            this.$refs.myModalRef.show();
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.itemsa = [];
          }
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
          this.items = [];
        });
    },
     modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm1");
    },
     modalConfirmnew() {
      this.form.UserDocuments[this.selecteObj.Document] = "";
      if (this.deleteflag == 1) {
        this.PoliceVerification = "";
        this.form.UserDocuments.PoliceVerification = "";
        this.$refs.policeFileInput && this.$refs.policeFileInput.reset();
      } else {
        this.MedicalCertificate = "";
        this.form.UserDocuments.MedicalCertificate = "";
        this.$refs.medicalFileInput && this.$refs.medicalFileInput.reset();
      }
      this.$root.$emit("bv::hide::modal", "modalConfirm1");
      this.$root.$emit("bv::show::modal", "combinedModal");
    },
    applyforJob(item, index, button) {
      this.showDismissibleAlert = false;
      var eventId = item.EventID;
      var userinfo = this.$store.getters.loggedUser;
      // console.log(userinfo);

      this.$store.dispatch("setJobDetails", eventId);

      if (this.maxnew > this.counter) {
        this.$refs.confirmApply.show();
      } else {
        this.isLoading = true;
        let promise = apis.getUserCategory(userinfo.UserId, item.BoardID);

        promise
          .then((response) => {
            // console.log("Reponse", response);
            if (response.status == 200) {
              if (response.bodyText == "Age Criteria not Fulfilled") {
                this.alertText =
                  "You Can not apply for this job; Age Criteria not Fulfilled";
                this.variant = "danger";
                this.showDismissibleAlert = true;
                this.isLoading = false;
                return;
              } else if (response.bodyText == "Board Mapping Not Available") {
                this.alertText =
                  "You Can not apply for this job; This Board is not selected by you as your job location.";
                this.variant = "danger";
                this.showDismissibleAlert = true;
                this.isLoading = false;
                return;
              } else {
                let paymentObj = {
                  BoardID: item.BoardID,
                  EventID: item.EventID,
                  EventTitle: item.EventTtile,
                  CategoryName: response.body.CategoryName,
                  CategoryTypeID: response.body.CategoryTypeID,
                  pmtPurpose: "Application Fees",
                  TransType: "Application Fees",
                };
                this.$store.dispatch("setPmtObject", paymentObj);
                this.$router.push({
                  name: "ApplicationFees",
                  params: { eventid: item.EventID },
                });
              }
            } else {
              this.alertText = "Error in Processing.";

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          })
          .catch((err) => {
            //console.log("err", err);
            this.alertText = err.body;
            this.showDismissibleAlert = true;
            this.variant = "danger";
            this.isLoading = false;
          });
      }

      /**/
    },
    submit() {
      this.isLoading2 = true;
      this.$router.push("/profile");
    },
    hideModal() {
      this.$refs.confirmApply.hide();
    },
    getProfileStatus() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUsePrfileStatus(userinfo.UserId);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            let rspns = response.body;
            console.log(this.getRegTyp);
            for (var x in rspns) {
              if (x != "ProfileNumber") {
                if (
                  (this.getRegTyp == 0 &&
                    x != "ExprienceDetail" &&
                    x != "PaymentStatus") ||
                  (this.getRegTyp == 3 && x != "ExprienceDetail") ||
                  this.getRegTyp == 1 ||
                  this.getRegTyp == 2 ||
                  this.getRegTyp >= 4
                ) {
                  //console.log(x, rspns[x]);
                  this.max++;
                  //Kms added on 7feb24
                  if (x != "ExprienceDetail" && x != "PaymentStatus") {
                    this.maxnew++;
                  }

                  if (rspns[x]) {
                    this.counter++;
                  }
                }
              }
            }

            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getBoardNames() {
      let promise = apis.readSGBoardName();

      promise
        .then((response) => {
          if (response.status == 200) {
            let rspns = response.body;
            this.$store.dispatch("setSGBList", rspns);
          } else {
            this.alertText = "Unable to Load Board List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = "Unable to Load Board List, " + err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    MarkNotificationRead(evt) {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.NotificationsMarkRead(userinfo.UserId);

      promiseU.then((response) => {
        this.notifications = [];
      });
    },
  },
  mounted() {
   this.events = [];
    var userinfo = this.$store.getters.loggedUser;
    this.token = this.$store.getters.authToken;
    this.userinfo = this.$store.getters.loggedUser;

    this.userId = userinfo.UserId;
    this.RegType = userinfo.RegistrationType;
    if (userinfo.PolicePending) {
      this.PolicePending = userinfo.PolicePending;
    }
    this.UserBFormID = userinfo.UserBFormID;
    this.loadImageList();
    if (userinfo.RegistrationType < 11) {
      this.$store.dispatch("setRegType", userinfo.RegisteredType);
      this.isLoading = true;
      let promise = apis.getEvents(userinfo.UserId);

      promise
        .then((response) => {
          if (response.status == 200) {
            this.events = response.body;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
      this.$nextTick(() => {
        this.getProfileStatus();
      });

      let PromiseN = apis.GetNotifications(userinfo.UserId);

      PromiseN.then((response) => {
        //console.log(response);
        if (response.status == 200) {
          this.notifications = response.body;
          if (this.notifications.length > 0) {
            this.$refs.mdlNotification.show();
          }
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  },
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue